// extracted by mini-css-extract-plugin
export default {"burgerButton":"BurgerMenuButton_burgerButton__w04WO","active":"BurgerMenuButton_active__AYvV-"};